<template>
  <div id="main">

    <div class="header">

      <div class="headtitle">
        <h4>智慧城市* 智能井盖 002 </h4>
      </div>
      <button @click="out">退出</button>
    </div>
    <div class="aside">
      <div class="search">
        <input type="search" placeholder="请输入设备名称或设备号" disabled>
      </div>
      <div class="ser">
        <div class="list_title">设备列表</div>
        <div class="list">
          <ul>
            <li v-for="(i,j) in liscon" v-bind:key="j" @click="liclick(i.imei,j)" :class="state==j?'checked':''">
              <i class="iconfont" :class="i.color">&#xe608;</i>
              <span>{{i.dc400Device.name}}</span></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="main">
      <div id="allmap"></div>
    </div>
    <div class="context">
      <div class="select">
        <select id="demo">
          <option value="1" disabled selected>请选择状态</option>
        </select>
      </div>
      <div class="con_title">
        <h3 @click="onOff=true">设备信息</h3>
        <h3 @click="onOff=false">历史记录</h3>
      </div>
      <div class="con_text" v-if="onOff">
        <ul>
          <li class="title"><i class="iconfont" :class="li_con.color">&#xe608;</i> <span> 智能井盖</span></li>
          <li>imei：<span :class="datecolor?'':'color'"> {{li_con.imei}}</span></li>
          <li>经度：<span :class="datecolor?'':'color'"> {{li_con.lng}}</span></li>
          <li>纬度：<span :class="datecolor?'':'color'"> {{li_con.lat}}</span></li>
          <li>电量：<span :class="datecolor?'':'color'"> {{li_con.battery}}</span></li>
          <li>上传时间：<span :class="datecolor?'':'color'"> {{li_con.eventTime}}</span></li>
          <li>是否移动：<span :class="datecolor?'':'color'"> {{li_con.move}}</span></li>
          <li>井盖距离底部：<span :class="datecolor?'':'color'"> {{li_con.hight}}</span></li>


        </ul>
      </div>
      <div class="history" v-if="!onOff">
        <div class="history_con">
          <div class="history_li" v-for="(i,j) in historylist" v-if="i" :key="(i,j)">
            <div class="history_cd" @click="lisnum=j" :class="lisnum!=j?'':'checked'">{{i.eventTime}}</div>
            <ul :class="lisnum!=j?'history_v':'history_v history_u'">
              <li class="title"><i class="iconfont" :class="i.color">&#xe608;</i> <span> 智能井盖</span></li>
              <li>imei：<span> {{i.imei}}</span></li>
              <li>经度：<span> {{i.lng}}</span></li>
              <li>纬度：<span> {{i.lat}}</span></li>
              <li>电量：<span> {{i.battery}}</span></li>
              <li>上传时间：<span> {{i.eventTime}}</span></li>
              <li>是否移动：<span> {{i.move}}</span></li>
              <li>井盖距离底部：<span> {{i.hight}}</span></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Loading} from 'element-ui';
  import iconBlue from '../../assets/img/wellLidBlue.png'
  import iconRed from '../../assets/img/wellLidRed.png'
  import iconGreen from '../../assets/img/wellLidGreen.png'

  export default {
    name: 'WellLid',
    data() {
      return {
        state: null,
        lists: null,
        iconblue: iconBlue,
        iconRed: iconRed,
        iconGreen: iconGreen,
        li_con: {

          hight: '暂未有信息',
          impact: '暂时未有信息',
          angle: '暂时未有信息',
          eventTime: '暂时未有信息',
          incline: '暂时未有信息',
          lat: '暂时未有信息',
          lng: '暂时未有信息',
          battery: '暂时未有信息',
          imei: '暂时未有信息',
          move: '暂时未有信息'
        },
        liscon: null,
        onOff: true,
        loadError: false,
        datecolor: false,
        lisnum: 0,
        useId: localStorage.getItem('userId'),
        markers: [],
        locations: [],
        popups: [],
        historylist: null,
      }
    },
    methods: {
      liclick(n, m) {
        this.state = m;
        let loadingInstance = Loading.service({
          lock: true,
          text: '加载中，请稍后',
          spinner: 'el-icon-loading',
          background: "rgba(0,0,0,.5)"
        });
        let _this = this;

        _this.markers[m].bindPopup('在这里').openPopup()
          //(m,_this.marker)

        _this.map.setView(_this.markers[m].getLatLng(), 15);
        this.$axios({
          method: "get",
          url: "/data/service/dc400/getHistoryData?imei=" + n
        }).then(res => {
          let data = res.data.data;
          this.datecolor = true;
          for (let i in data) {
            data[i].eventTime = formatTime(res.data.data[i].eventTime);
            data[i].move = this.moved(res.data.data[i].move);
            data[i].battery = this.battery(res.data.data[i].battery);
            if (data[i].move == '被移动') {
              data[i].color = 'red'
            } else {
              data[i].color = 'blue'
            }
          }
          this.historylist = data;
          loadingInstance.close()
        })
        for (let i  in this.liscon) {
          if (this.liscon[i].imei == n) {
            this.li_con = this.liscon[i]
          }
        }
      },
      out() {
        this.$router.push({path: "/product"});
      },
      loading(a) {//是否显示加载动画
        this.loadFlag = a;
      },
      moved(n) {
        if (n == 0) {
          return '未移动'
        } else {
          return '被移动'
        }
      },
      battery(n) {
        if (n == 0) {
          return '充足'
        } else {
          return '不足'
        }
      }

    },
    mounted() {

      let $this = this;
      let useId = $this.useId;
      let map = L.map('allmap').setView([sessionStorage.getItem('lat'), sessionStorage.getItem('lng')], 10)
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: ''
      }).addTo(map);
      let markers = [];

      function clearOverlays() {
        if (markers) {
          for (let i in markers) {
            markers[i].remove();
          }
        }
      }

      demo();

      function demo() {
        let loadingInstance = Loading.service({
          lock: true,
          text: '加载中，请稍后',
          spinner: 'el-icon-loading',
          background: "rgba(0,0,0,.5)"
        });
        clearOverlays();
        $this.state = null;
        $this.datecolor = false;
        $this.li_con = {
          hight: '暂未有信息',
          impact: '暂时未有信息',
          angle: '暂时未有信息',
          eventTime: '暂时未有信息',
          incline: '暂时未有信息',
          lat: '暂时未有信息',
          lng: '暂时未有信息',
          battery: '暂时未有信息',
          imei: '暂时未有信息',
          move: '暂时未有信息'
        }

        $this.$axios({
          method: "get",
          // url: "/data/service/dc400/getDeviceData?userId=" + useId
          url: "/data/service/dc400/getRecentData?userId=" + useId
        }).then(res => {
          let Data = res.data.data;
          $this.markers = [];
          $this.liscon = [];
          // $this.state=null
          for (let i = 0; i < Data.length; i++) {
            Data[i].eventTime = formatTime(Data[i].eventTime);
            Data[i].move = $this.moved(Data[i].move);
            Data[i].battery = $this.battery(Data[i].battery);
            Data[i].hight = Data[i].hight + 'mm';
            chang(Data[i], i)
          }
          loadingInstance.close();
          setTimeout(function () {
            demo()
          }, 60000)
        });
      }

      function chang(data, n) {
        var icon

        if (data.move == '被移动') {
          icon = $this.iconRed;
          data.color = 'red'
        } else {
          icon = $this.iconblue;
          data.color = 'blue'
        }


        var myIcon = L.icon({
          iconUrl: icon,
          iconSize: [50, 50],
          iconAnchor: [25, 25]
        });


        let marker = L.marker([data.lat, data.lng], {icon: myIcon}).addTo(map);

        $this.markers.splice(n, 0, marker);
        $this.locations.splice(n, 0, [data.lat, data.lng]);
        $this.map = map;
        $this.liscon.splice(n, 0, data);
        marker.on("click", function () {
          $this.marker = marker;

          $this.liclick(data.imei, $this.markers.indexOf(marker));
          $this.li_con = data;
          map.setView([data.lat, data.lng], 15);
        })


      }
    },
    components: {}
  }

  function formatTime(time) {
    // var localOffset=new Date().getTimezoneOffset()*60;
    // let unixtime = time+localOffset;
    // let unixTimestamp = new Date(unixtime * 1000);
    let unixTimestamp = new Date(time * 1000 + 3600000*8);//本地区毫秒值
        //     console.log('转换前的0时区'+time);
        // console.log('本地时间为'+unixTimestamp/1000);
    let Y = unixTimestamp.getFullYear();
    let M = ((unixTimestamp.getMonth() + 1) > 10 ? (unixTimestamp.getMonth() + 1) : '0' + (unixTimestamp.getMonth() + 1));
    let D = (unixTimestamp.getDate() >= 10 ? unixTimestamp.getDate() : '0' + unixTimestamp.getDate());
    let H = (unixTimestamp.getHours() >= 10 ? unixTimestamp.getHours() : '0' + unixTimestamp.getHours());
    let N = (unixTimestamp.getMinutes() >= 10 ? unixTimestamp.getMinutes() : '0' + unixTimestamp.getMinutes());
    let S = (unixTimestamp.getSeconds() >= 10 ? unixTimestamp.getSeconds() : '0' + unixTimestamp.getSeconds());
    let toDay = Y + '-' + M + '-' + D + " " + H + ":" + N + ":" + S
    return toDay
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import "../../assets/font/iconfont.css";

  h1, h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  ul li {
    white-space: nowrap;
    overflow: hidden;
  }

  .color {
    color: rgba(207, 214, 211, 0.9);
  }

  #main {
    width: 100%;
    height: 100%;
    position: fixed;
    background-color: #ffffff;
  }

  #main .red {
    color: red;
  }

  #main .blue {
    color: #53a1ff;
  }

  #main #allmap {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  .header {
    width: 100%;
    height: 6%;
    overflow: hidden;
    color: #fff;
    border-bottom: 1px solid rgba(92, 120, 201, 0.49);
    position: relative;
    background-image: linear-gradient(to bottom, #799fff, rgba(83, 161, 255, 0.77), #6c96ff);
  }

  .header:before {
    content: "";
    position: absolute;
    top: -10px;
    left: 0;
    width: 100%;
    height: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.8);
    z-index: 100;
  }

  .header .headtitle {
    position: absolute;
    height: 30px;
    left: 2%;
    line-height: 30px;
    top: 50%;
    margin-top: -15px;
  }

  .header .logo {
    position: absolute;
    height: 30px;
    overflow: hidden;
    line-height: 30px;
    top: 50%;
    left: 2%;
    width: 160px;
    margin-top: -15px;
  }

  .header .logo img {
    width: 100%;
    height: 100%;
  }

  .header button {
    width: 40px;
    border: none;
    outline: none;
    position: absolute;
    cursor: pointer;
    right: 30px;
    top: 50%;
    font-size: 16px;
    color: #ffffff;
    margin-top: -20px;
    height: 40px;
    background-color: transparent;

  }

  .main, .aside, .context {
    height: 94%;
    float: left;
    background-color: rgba(215, 230, 255, 0.1);
  }

  .aside {
    box-sizing: border-box;
    padding-top: 50px;
    position: relative;
    width: 15%;
    border-right: 1px solid #caccd4;
  }

  .aside .ser {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
    padding-top: 40px;
  }

  .search {
    width: 100%;
    height: 50px;
    position: absolute;
    left: 0;
    background-color: #53a1ff;
    top: 0;
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .search input {
    width: 100%;
    text-indent: 1.5em;
    height: 30px;
    border-radius: 8px;
    outline: none;
    border: 1px solid #c8c9cb;
    line-height: 30px;

  }

  .aside .ser .list {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  .aside .ser .list ul {
    width: 100%;
    box-sizing: border-box;

  }

  .aside .ser .list ul li {
    width: 100%;
    box-sizing: border-box;
    padding: 5px 20px;
    font-size: 18px;
    cursor: pointer;
  }

  .aside .ser .list .loading {
    margin-top: 40px;
  }

  .aside .ser .list ul li.checked {
    background-color: #8eb5fa;
    color: #fff;
  }

  .aside .ser .list ul li i {
    color: #5a8cf2;
    margin-right: 10px;
  }

  .history_v {
    width: 100%;
    height: 0;
    overflow: hidden;
    box-sizing: border-box;
    border-bottom: 1px solid transparent;
    transition: all .5s ease;
  }

  .history_v .title i {
    color: #5a8cf2;
  }

  .history_cd.checked {
    color: #ffffff;
    background-color: #8eb5fa;
  }

  .history_u {
    height: 250px;
    border-color: #d6ddef;
  }

  .history_cd {
    width: 100%;
    text-indent: 2em;
    font-size: 16px;
    line-height: 30px;
    box-sizing: border-box;
    cursor: pointer;
    border-bottom: 1px solid rgba(112, 119, 125, 0.24);
  }

  .list_title {
    height: 40px;
    width: 100%;
    position: absolute;
    line-height: 40px;
    font-size: 18px;
    font-weight: 600;
    top: 0;
    background-color: #ffffff;
    text-align: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.11);
  }

  .main {
    width: 70%;

  }

  .context {
    width: 15%;
    box-sizing: border-box;
    border-left: 1px solid #dbdade;
  }

  .context .select {
    height: 50px;
    box-sizing: border-box;
    padding: 10px 20px;
    background-color: #53a1ff;
  }

  .context .select select {
    height: 30px;
    width: 100%;
    border-radius: 8px;
  }

  .con_title {
    line-height: 40px;
    height: 40px;
    border-bottom: 1px solid rgba(192, 198, 201, 0.42);
    text-align: center;
  }

  .con_title h3 {
    width: 50%;
    box-sizing: border-box;
    float: left;
  }

  .con_title h3:first-of-type {
    border-right: 1px solid #edf1f4;
  }

  .con_text {
    width: 100%;
    height: 100%;
    overflow: auto;
    position: relative;
  }

  .con_text li {
    box-sizing: border-box;
    padding: 0 20px;
    height: 30px;
    font-size: 16px;
    color: #333;
    line-height: 30px;
  }

  .con_text ul .title {
    height: 40px;
    color: #000;
    line-height: 40px;
    text-align: center;
  }

  .con_text ul {
    margin-top: 10px;
  }

  .con_text ul .title i {
    color: #54a3ff;
    vertical-align: top;
    font-size: 30px !important;

  }

  .con_text ul .title span {
    vertical-align: top;
  }

  .history {
    height: 90%;
    width: 100%;
    box-sizing: border-box;
    position: relative;

    border-top: 1px solid rgba(170, 165, 179, 0.36);
  }

  .history .history_title {
    width: 100%;
    height: 40px;
    position: absolute;
    top: 0;
    color: #fff;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 16px;
    text-indent: 1em;
    border-bottom: 1px solid rgba(170, 165, 179, 0.36);
    text-align: left;
    background-color: #53a1ff;
  }

  .history li {
    box-sizing: border-box;
    padding-left: 20px;
    height: 30px;
    font-size: 16px;
    color: #333;
    line-height: 30px;
  }

  .history_con {
    width: 100%;
    height: 100%;
    overflow: auto;
  }

  html {
    height: 100%;
  }

  body {
    height: 100%;
    background: #EA4961;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  body {
    background: #eaecfa;
  }

  @-webkit-keyframes enter {
    0% {
      opacity: 0;
      top: -10px;
    }
    5% {
      opacity: 1;
      top: 0px;
    }
    50.9% {
      opacity: 1;
      top: 0px;
    }
    55.9% {
      opacity: 0;
      top: 10px;
    }
  }

  @keyframes enter {
    0% {
      opacity: 0;
      top: -10px;
    }
    5% {
      opacity: 1;
      top: 0px;
    }
    50.9% {
      opacity: 1;
      top: 0px;
    }
    55.9% {
      opacity: 0;
      top: 10px;
    }
  }

  @-moz-keyframes enter {
    0% {
      opacity: 0;
      top: -10px;
    }
    5% {
      opacity: 1;
      top: 0px;
    }
    50.9% {
      opacity: 1;
      top: 0px;
    }
    55.9% {
      opacity: 0;
      top: 10px;
    }
  }

  .loadError {
    width: 100%;
    text-align: center;
    color: #b5c3d5;
  }

  @media screen and (max-width: 1600px) {
    .aside .ser .list ul li {
      font-size: 12px;
    }

    .history li {
      font-size: 12px;
    }

    .history .history_title {
      font-size: 14px;
    }

    .aside .ser {
      font-size: 14px;
    }

    .aside .list_title {
      font-size: 14px;
    }

    .loadError {
      font-size: 14px;
    }

    #demo {
      font-size: 12px;
    }

    .con_title h3 {
      font-size: 14px;
    }

    .con_text ul li {
      font-size: 12px;
    }

    .header .logo {
      width: 110px;
      height: 20px;
      margin-top: -10px;
      overflow: inherit;
    }

    .header {
      font-size: 14px;
    }

    .header button {
      font-size: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/wellLid/wellLid2.vue